var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"register-password-view"}},[_c('div',{staticClass:"flex f-ai",attrs:{"id":"header"}},[_c('p',[_vm._v(_vm._s(_vm.$t('password.change')))])]),_c('SetPassword',{attrs:{"auth":_vm.auth,"token":_vm.token}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }